import { render, staticRenderFns } from "./RevertForm.vue?vue&type=template&id=789ab3f8&"
import script from "./RevertForm.vue?vue&type=script&lang=js&"
export * from "./RevertForm.vue?vue&type=script&lang=js&"
import style0 from "./RevertForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports